// subheader.component.ts
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-breadcrumb',
  template: `
    <subheader [title]="header.title" [breadcrumb]="header.breadcrumb"></subheader>
  `
})
export class BreadcrumbComponent {
  @Input() header: any;
}
